import axios from 'axios';

import { getBaseUrl, getSiteOwnership, log } from 'common/utils';
import { ENV, VALID } from 'common/const';

import mock from './requestOtp.mock';

const baseUrl = getBaseUrl(2);
const ownership = getSiteOwnership();

/**
 * Requests a one-time passcode be emailed to the customer
 * @param {string} user.email
 * @returns "Successful" string
 */
const requestOtp = async ({ email }) => {
  await VALID.checkAll(['Email', email, VALID.EMAIL]);

  try {
    if (ENV.IS_MOCK) {
      mock();
    } else {
      await axios.post(`${baseUrl}customer/request_otp`, {
        email: `${email}`,
        ownership: `${ownership}`,
      });
    }
  } catch (error) {
    log('requestOtp', {
      api: error.response?.status !== 400,
      data: { email },
      error,
      throw: true,
      type: 'request',
    });
  }
};

export default requestOtp;
